import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { Topbar } from './Topbar';

interface RootLayoutProps {
  /**
   * Ações da direita da `Topbar`.
   *
   * Existe porque o mesmo `RootLayout` serve as duas ramificações do router,
   * inclusive o catch-all público. O que depende de sessão (toggle
   * de experiência, carrinho) é passado só pelo ramo protegido — montá-lo aqui
   * o faria rodar com `user: null`.
   */
  rightSlot?: ReactNode;
  /** Idem, para a busca entre a marca e as ações. Omitida, a marca fica só. */
  searchSlot?: ReactNode;
  /** Idem, para as ações do celular. Ver `TopbarProps.mobileSlot`. */
  mobileSlot?: ReactNode;
}

export function RootLayout({
  rightSlot,
  searchSlot,
  mobileSlot,
}: RootLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Topbar
        rightSlot={rightSlot}
        searchSlot={searchSlot}
        mobileSlot={mobileSlot}
      />
      {/* `overflow-x-clip` (e não `hidden`): o hero da pronta entrega sai do
          container com `w-screen`, e o `scrollbar-gutter: stable` do `html`
          faz 100vw incluir a calha da barra — sem o clip sobraria uma rolagem
          horizontal da largura da barra. `clip` não cria contexto de rolagem,
          então o `sticky` da faixa do carrinho continua preso à viewport. */}
      <main className="flex flex-1 flex-col overflow-x-clip">
        <Outlet />
      </main>
      {/* Fora do `main`, e depois dele: o rodapé é conteúdo do site, não da
          página, e dentro do `main` ele entraria no landmark que os leitores
          de tela usam para pular direto ao conteúdo.

          Mora no `RootLayout`, então alcança vitrine e 404 — mas
          NÃO o self-service nem o catálogo público, que têm layout próprio. */}
      <Footer />
    </div>
  );
}
